import React from 'react';
import { MailIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-plum text-white" data-id="element-56" data-mp="3gezfnanhw34b">
      <div className="mx-auto max-w-4xl px-5 py-12 text-center" style={{
      paddingTop: "25px"
    }} data-id="element-57" data-mp="3ggtwodvnbb34">
        <p className="font-display text-xl font-black text-white" data-id="element-58" data-mp="32pp764lzrz6i">
          SIGMA SMART<span className="align-super text-xs" data-id="element-59" data-mp="36q92r3qx2uqj">™</span> — 100+ PROMPTS IA POUR LES FORCES DE L’ORDRE<span className="align-super text-xs" data-id="element-60" data-mp="3ug3gdnj28nbu">™</span>
        </p>

        <p className="mt-4 font-display text-base font-semibold italic text-grape-soft" data-id="element-61" data-mp="38h5paxxbklh">
          “Des systèmes pratiques pour travailler plus efficacement avec l’intelligence artificielle.”
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-white/75" data-id="element-62" data-mp="3qd6u9muba935">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-white" data-id="element-63" data-mp="29yxdbdsefmmc">
            <MailIcon className="h-4 w-4 text-blush" data-id="element-64" data-mp="2evx98vvjb8zq" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-white" data-id="element-65" data-mp="3lbddywk4gfne">
            <InstagramIcon className="h-4 w-4 text-blush" data-id="element-66" data-mp="3v7ggi3ivygav" /> @sigmasmart.french
          </a>
        </div>

        <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-white/55" data-id="element-67" data-mp="3q83tnis0l98a">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-68" data-mp="82idhvaq8efw">
            Conditions générales
          </a>
          <span data-id="element-69" data-mp="33e69a7d4qs7">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-70" data-mp="31umh9mhzxlo">
            Politique de confidentialité
          </a>
          <span data-id="element-71" data-mp="ctgxp5yu5wof">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-72" data-mp="cu8u2j09byfr">
            Support
          </a>
        </div>

        <p className="mt-8 text-xs leading-relaxed text-white/45" data-id="element-73" data-mp="mrwpzc9lnbzi">
          © 2026 SIGMA SMART™ — Tous droits réservés.
        </p>
      </div>
    </footer>;
}